import { Badge, BadgeProps } from 'antd'
import React, { memo, useCallback } from 'react'
import { Dayjs } from 'dayjs'

interface ListDataItem {
  type: string
  content: string
}

interface DefaultCellTemplateProps {
  listData: ListDataItem[]
  value: Dayjs
  clickCell: (value: Dayjs) => void
  isMobile?: boolean
}

export const DefaultCellTemplate = memo((props: DefaultCellTemplateProps) => {
  const {listData, value, clickCell, isMobile = false} = props

  const handleClickCell = useCallback((value: Dayjs) => () => {
    clickCell(value)
  }, [clickCell])

  return (
    <ul onClick={handleClickCell(value)} style={{height: '100%', cursor: 'pointer'}}>
      {listData.map(item => (
        <li key={item.content}>
          <Badge 
            status={item.type as BadgeProps['status']} 
            text={
              <span 
                data-mobile={isMobile ? "true" : "false"}
                data-count={isMobile ? item.content : undefined}
              >
                {item.content}
              </span>
            }
          />
        </li>
      ))}
    </ul>
  )
})
